/* global Office, module, require */
import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ThemeProvider } from "@fluentui/react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContextProvider } from "./context/AppContext";
import { FC } from "react";
import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";

initializeIcons();

const config = {
  auth: { clientId: "ff5cc66a-5eac-4328-b68e-04d0a6016c1c" },
  cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
};
export const msal = new PublicClientApplication(config);

let isOfficeInitialized = false;

const title = "Midthaug priskalkulator";

const render = (Component: FC<any>) => {
  ReactDOM.render(
    <AppContainer>
      <ThemeProvider>
        <AppContextProvider>
          <Component title={title} isOfficeInitialized={isOfficeInitialized} />
        </AppContextProvider>
      </ThemeProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
